<template>
  <template v-if="route.name?.substr(route.name.length - 11) === 'StaffDetail'">
    <StaffHeader></StaffHeader>
  </template>
  <template v-else>
    <Header
      v-if="
        !(route.name?.substr(route.name.length - 10) === 'LiveStream') &&
        !(route.name?.substr(route.name.length - 13) === 'Authorization')
      "
    />
  </template>
  <main>
    <router-view />
  </main>
  <template v-if="route.name?.substr(route.name.length - 11) === 'StaffDetail'">
  </template>
  <template v-else>
    <Footer
      v-if="
        !(route.name?.substr(route.name.length - 10) === 'LiveStream') &&
        !(route.name?.substr(route.name.length - 13) === 'Authorization')
      "
    />
  </template>
</template>

<script>
import { useLanguage } from "./utils/language";
import Header from "./components/Header";
import StaffHeader from "./components/staff/StaffHeader";
import Footer from "./components/Footer";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { watch } from "vue";

export default {
  components: {
    Header,
    StaffHeader,
    Footer,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const { i18nRoute } = useLanguage();

    watch(
      () => store.getters.theme,
      (newTheme) => {
        newTheme =
          newTheme === "dark" || newTheme === "light" ? newTheme : "dark";
        typeof document !== "undefined" &&
          document.querySelector("html").setAttribute("data-theme", newTheme);
        typeof localStorage !== "undefined" &&
          localStorage.setItem("theme", newTheme);
      },
      { immediate: true }
    );

    const refreshToken = () => {
      if (store.getters.access || store.getters.refresh)
        store.dispatch("refreshToken", {
          err: () => {
            if (route.name.substr(route.name.length - 11) === "StaffDetail") {
              router.push(i18nRoute({ name: "LogIn_Authorization" }));
            }
            store.commit("flushTokens");
          },
        });
    };

    refreshToken();

    watch(
      () => route.name,
      (routeName) => {
        if (store.getters.access || store.getters.refresh) {
          store.dispatch("verifyToken", {
            cb: () => {},
            err: refreshToken,
          });
        } else if (routeName.substr(route.name.length - 11) === "StaffDetail") {
          router.push(i18nRoute({ name: "LogIn_Authorization" }));
        }
      }
    );

    return {
      route,
    };
  },
};
</script>

<style lang="scss">
:root {
  --header-main-height: calc(max(70px, 5vw));
  --main-wrapper-width: clamp(375px, 90%, 1720px);
  --left-width: clamp(375px, 100%, 765px);
  --left-whole-width: calc(
    clamp(5%, calc((100% - 1720px) / 2), 100%) + var(--left-width)
  );
  --drawer-width: 240px;
  --words-bg-url: url("./assets/words-bg.png");
  --words-bg-light-url: url("./assets/words-bg-light.png");

  --user-bg-color: #f0f0f0;
  --user-edit-bg-color: #ededed;

  color: var(--primary-font-color);
  font-size: 16px;
}

html {
  // light
  --primary-font-color: #121212;
  --secondary-font-color: #fff;
  --highlight-font-color: #007bff;
  --primary-bg: 255, 255, 255;
  --secondary-bg: 18, 18, 18;
  --background-color: #fff;
  --foreground-color: #121212;

  &[data-theme="dark"] {
    --primary-font-color: #fff;
    --secondary-font-color: #121212;
    --highlight-font-color: #0063ce;
    --primary-bg: 18, 18, 18;
    --secondary-bg: 255, 255, 255;
    --background-color: #121212;
    --foreground-color: #fff;
  }
}

@media screen and (max-width: 992px) {
  :root {
    --header-main-height: 78px;
    font-size: 14px;
  }
}

@media screen and (max-width: 768px) {
  :root {
    --header-main-height: 52px;
  }
}

@media screen and (max-width: 375px) {
  :root {
    --main-wrapper-width: 90%;
  }
}

img[alt] {
  color: transparent;
}

img:after {
  font-weight: 900;
  font-family: "Font Awesome 5 Pro";
  content: "\f071"" Broken Image of " attr(alt);
  display: block;
  font-size: 16px;
  font-style: normal;
  color: rgb(100, 100, 100);

  position: absolute;
  top: 40%;
  width: 100%;
  text-align: center;
}

b,
strong {
  font-weight: bold;
}

blockquote {
  border-left: 0.3em solid grey;
  margin-top: 1em;
  margin-bottom: 1em;
  font-style: italic;
  p {
    padding: 0.6em 2em;
  }
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

i,
em {
  font-style: italic;
}

input,
textarea,
button,
select,
div,
a {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.spinner-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.lds-spinner {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-spinner div {
  background-color: yellow;
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 6px;
  height: 18px;
  border-radius: 20%;
  background-color: var(--foreground-color);
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}

@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes fade-pulse {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes progress-filler {
  to {
    width: 100%;
  }
}

@keyframes example {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}

html {
  background-color: var(--background-color);
  font-family: "Roboto", sans-serif;
}

a {
  text-decoration: none;
  color: inherit;
}

* {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  box-sizing: border-box;
  word-break: break-word;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease !important;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fromtop-enter-active,
.fromtop-leave-active {
  transition: all 0.6s ease !important;
}

.fromtop-enter-from,
.fromtop-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}

.frombottom-enter-active,
.frombottom-leave-active {
  transition: all 0.6s ease !important;
}

.frombottom-enter-from,
.frombottom-leave-to {
  opacity: 0;
  transform: translateY(700px);
}

.fromleft-enter-active,
.fromleft-leave-active {
  transition: all 0.6s ease !important;
}

.fromleft-enter-from,
.fromleft-leave-to {
  opacity: 0;
  transform: translateX(-50%);
}

.fromright-enter-active,
.fromright-leave-active {
  transition: all 0.6s ease !important;
}

.fromright-enter-from,
.fromright-leave-to {
  opacity: 0;
  transform: translateX(50%);
}

.btn-primary {
  position: relative;
  font-size: calc(max(18px, 1.2vw));
  transition: all 0.4s ease;
  cursor: pointer;
  border-radius: 4px;
  color: var(--secondary-font-color);
  // background: var(--foreground-color);
}

.flat-btn {
  padding: 8px 16px;
  border: 1px solid var(--primary-font-color);
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.4s;
  font-family: Roboto, sans-serif;
  background-color: rgba(var(--primary-bg), 0.2);
  text-shadow: none !important;

  &:hover {
    background-color: var(--foreground-color);
    color: var(--secondary-font-color);
  }
}

img {
  background-color: lightgray;
  object-fit: cover;
}

.limited-text {
  --snup: 3;
  display: -webkit-box;
  -webkit-line-clamp: var(--snup);
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.kground {
  /*отвечает за анимацию при загрузки страницы */
  width: inherit;
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px;
  height: inherit;
  pointer-events: none;
  position: relative;
  line-height: 1em;
  font-size: 0.6em;
  color: rgba(0, 0, 0, 0);
}

.pointer-none {
  pointer-events: none !important;
}

.shimmer-title {
  mix-blend-mode: unset !important;
}

.animated-first-letter {
  &::first-letter {
    background: linear-gradient(
      to right,
      #eeeeee 8%,
      #dddddd 18%,
      #eeeeee 33%
    ) !important;
    background-size: 800px !important;
  }
}

.animated-img {
  @keyframes rotate {
    0% {
      -webkit-transform: rotate3d(0, 0, 1, 0deg);
      transform: rotate3d(0, 0, 1, 0deg);
    }
    25% {
      -webkit-transform: rotate3d(0, 0, 1, 90deg);
      transform: rotate3d(0, 0, 1, 90deg);
    }
    50% {
      -webkit-transform: rotate3d(0, 0, 1, 180deg);
      transform: rotate3d(0, 0, 1, 180deg);
    }
    75% {
      -webkit-transform: rotate3d(0, 0, 1, 270deg);
      transform: rotate3d(0, 0, 1, 270deg);
    }
    100% {
      -webkit-transform: rotate3d(0, 0, 1, 360deg);
      transform: rotate3d(0, 0, 1, 360deg);
    }
  }
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  &.main-image {
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
    background-size: 800px;
    height: 100%;
    border: none !important;
    img {
      display: none;
    }
  }
}
@keyframes scale {
  0% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1.1);
  }
}
.earth-news {
  background-color: #10604a;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  position: relative;
  animation: scale 1.5s alternate infinite ease-in;
  @media screen and (max-width: 768px) {
    width: 8px;
    height: 8px;
  }
  &::after {
    content: "";
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 3px solid #10604a;
    @media screen and (max-width: 768px) {
      width: 20px;
      height: 20px;
    }
  }
  &::before {
    content: "";
    position: absolute;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    background-color: #9fe3cd;
    transform: translate(-50%, -50%);
    z-index: -1;
    @media screen and (max-width: 768px) {
      width: 12px;
      height: 12px;
    }
  }
}
</style>

<i18n>
{
  "en": {
  }
}
</i18n>
